import { useRequest } from 'hooks/useRequest'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'


const Footer = ({footerLogoPath, etbisImagePath, etbisUrl}) => {
  const [request, loading] = useRequest()
  const [footer, setFooter] = useState([])
  const navigate = useNavigate();


  useEffect(() => {
      request('/StaticPage', {
        method: 'GET',

      }).then((res) => {
        if (res?.data) {
          setFooter(res?.data?.result)
        }
      })

  }, [])

  const redirect = (url) => {
    if (url.externalUrl) {
      window.open(url.externalUrl, "_blank")
    } else if (url.url) {
      window.scrollTo(0,0);
      navigate("/sayfa/" + url.url)
    }

  }

  return (
    !loading && <div className='footer'>

    {/* {footerLogoPath && <img src={footerLogoPath} alt="" className="footer-image" />} */}
    <img style={{cursor: "pointer"}} onClick={() => window.location.href = "https://www.tavukdunyasi.com/"} src={footerLogoPath} alt='Logo' className='footer-image' />

    <div className='footer-mid'>
      {footer.map((foo, i) => (
        <div className='footer-title header-s' key={i} onClick={() => redirect(foo)}> {foo.title.replace(/ğ/g, 'Ğ').replace(/ı/g, 'I').replace(/i/g, 'İ').replace(/ş/g, 'Ş').replace(/ü/g, 'Ü').replace(/ö/g, 'Ö').toUpperCase()}</div>
      ))}
    </div>

    <a target='_blank' href={etbisUrl} rel="noreferrer"><img src={etbisImagePath} className='footer-image2' /></a>


    {/* {footerLogoPath && <img src={footerLogoPath} alt="" className="footer-image" />} */}

    {/* <div className='footer-right'>
      {footer.map((foo, i) => (
        i > 1 &&
        <div className='footer-title' key={i} onClick={() => redirect(foo)}> {foo.title}</div>
      ))}
    </div> */}
  </div>
  )
}

export default Footer

